"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadsSaveForLaterKeys = undefined;

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _union = require("lodash/union");

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// For saved for later success just update status to saved and dispatch event in under review compoent to fire call to get new active
//
var uploadsSaveForLaterKeys = exports.uploadsSaveForLaterKeys = function uploadsSaveForLaterKeys() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    var uploads = {},
        nextState = {};

    switch (action.type) {
        case actionTypes.FETCH_SAVED_UPLOADS_SUCCESS:
            uploads = action.response;
            nextState = uploads.keys;
            return Object.assign([], state, nextState);
            break;

        case actionTypes.SAVE_UPLOAD_FOR_LATER_SUCCESS:
            uploads = action.response;
            nextState = uploads.keys;
            return Object.assign([], state, nextState);
            break;

        default:
            return state;
            break;
    }
};